import template from './security.html';
import controller from './security.controller.js';

const profileSecurityComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default profileSecurityComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/security/security.component.js
 **/